import { Todo } from "../../../Types/Todo";
import { useEffect, useRef, useState } from "react";
import RenderOrderItem from "../Orders/RenderOrderItem";
import RenderBidItem from "../Bids/renderBidItem";
import RenderNudgeItem from "../Nudges/RenderNudgeItem";
import { Order } from "../../../Types/Order";
import { Button } from "reactstrap";

type Props = {
    todo: Todo;
    sticky?: boolean;
    stickyTop?: number;
    bg?: string;
};

type Tab = 'Tab1' | 'Tab2' | 'Tab3';

const TodoTabs = ({ 
    todo,
    sticky = false,
    stickyTop = 0,
}: Props ) => {
    const orders = todo?.orders;
    const nudges = todo?.nudges;
    const bids = todo?.bids;
    const [activeTab, setActiveTab] = useState<Tab>('Tab1');
    const [order, setOrder] = useState<Order[]>([]);
    const [orderError, setOrderError] = useState<string>('');
    const [bidError, setBidError] = useState<string>('');

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        })
    }, []);

    const handleRemoveOrder = (deleteOrderID: string) => {
        setOrder(prev =>
            prev.filter(order => order.id !== deleteOrderID)
        );
    };

    const handleOrderError = (error: string) => setOrderError(error);
    const handleBidError = (error: string) => setBidError(error);

    const tabContent = () => {
        switch (activeTab) {
            case 'Tab1':
                return (
                    <div>
                        {orders?.length === 0 
                        ? (
                            <div>
                                <span>No Orders Due</span>
                            </div>
                        ) : (
                            <div>
                                {orderError && 
                                    <span style={{ color: 'red', padding: 5 }}>ERROR: {orderError}</span>
                                }
                                <div key="orders">
                                    {orders?.map((item) => (
                                        <RenderOrderItem
                                            key={item.id}
                                            item={item}
                                            onError={handleOrderError}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                );
            case 'Tab2':
                return (
                     <div>
                        {bids?.length === 0 
                        ? (
                            <div>
                                <span>No Bids Due</span>
                            </div>
                        ) : (
                            <div>
                                {bidError &&
                                    <span style={{ color: 'red', padding: 5 }}>ERROR: {bidError}</span>
                                }
                                <div key="bids">
                                    {bids?.map((item) => (
                                        <RenderBidItem
                                            key={item.quoteID}
                                            item={item}
                                            onError={handleBidError}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                );
            case 'Tab3':
                return (
                     <div>
                        {nudges?.length === 0 
                        ? (
                            <div>
                                <span>No Open Orders</span>
                            </div>
                        ) : (
                            <div>
                                <div key="nudges">
                                    {nudges?.map((item) => (
                                        <RenderNudgeItem
                                            key={item._id}
                                            item={item} 
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                );
            default:
                break;
        }
    }
    
    return (
        <div
            style={{ flex: 1, }}
        >
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    position: sticky ? 'sticky' : 'static',
                    top: sticky ? stickyTop : undefined,
                    zIndex: sticky ? 1000 : undefined,
                    paddingBlock: '10px',
                }}
                className={stickyTop > 0 ? 'bg-light' : 'bg-white'}
            >
                <Button 
                    className={activeTab === 'Tab1' ? `tabButton bg-primary` : `tabButton bg-white`}
                    onClick={() => setActiveTab('Tab1')}
                >
                    <span style={{ fontWeight: 'bold' }}>Orders</span>
                </Button>
                <Button 
                    className={activeTab === 'Tab2' ? `tabButton bg-primary` : `tabButton bg-white`}
                    onClick={() => setActiveTab('Tab2')}
                >
                    <span style={{ fontWeight: 'bold' }}>Bids</span>
                </Button>
                <Button 
                    className={activeTab === 'Tab3' ? `tabButton bg-primary` : `tabButton bg-white`}
                    onClick={() => setActiveTab('Tab3')}
                >
                    <span style={{ fontWeight: 'bold' }}>Nudges</span>
                </Button>
            </div>
            <div>
                {tabContent()}
            </div>
        </div>
    )
};

export default TodoTabs;